// Sample testimonials — replace with genuine client quotes before relying on them publicly.
// No review/rating structured data is generated from these; star-rating schema requires real, verifiable review data.
export const TESTIMONIALS = [
  {
    quote:
      "The patrol reports land in my inbox every morning — timestamps, photos, everything. For the first time I can actually prove to our insurer that the yard is being checked.",
    role: "Facilities Manager",
    location: "Belfast",
    sector: "Logistics & Warehousing",
  },
  {
    quote:
      "Their door team completely changed the atmosphere at our venue. Professional with customers, firm when it matters, and the incident paperwork is immaculate.",
    role: "General Manager",
    location: "Derry / Londonderry",
    sector: "Hospitality & Nightlife",
  },
  {
    quote:
      "We had plant stolen from two sites before bringing Xtreme Protection in. Gatehouse control plus monitored CCTV — we have not lost so much as a drill since.",
    role: "Contracts Director",
    location: "Craigavon",
    sector: "Construction",
  },
  {
    quote:
      "Alarm callouts used to mean our duty manager driving in at 3am. Now a response officer attends, secures the building and emails the report. Our staff are safer and better rested.",
    role: "Operations Manager",
    location: "Newry",
    sector: "Retail",
  },
  {
    quote:
      "They stewarded our festival for three days — 8,000 people, zero serious incidents, and a debrief report that made next year's planning straightforward.",
    role: "Event Organiser",
    location: "Enniskillen",
    sector: "Events & Festivals",
  },
  {
    quote:
      "Our reception security officer is the first face our clients see. Smart, welcoming, and completely on top of visitor management. They represent us better than we could.",
    role: "Office Manager",
    location: "Lisburn",
    sector: "Corporate",
  },
];
